import { BodyText, Button, Callout } from "@/components/ui";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { SEVERITY_LEVEL_LABELS } from "../network/useInteractionChecking";
import type { InteractionCheckingResponse } from "../network/useInteractionChecking";

interface InteractionsProps {
  interactionCheckingData: InteractionCheckingResponse;
  medicationRequestId: string;
}

export const Interactions = ({
  interactionCheckingData,
  medicationRequestId,
}: InteractionsProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Callout title="Interactions" variant="danger">
      <div
        className={cn(
          "flex flex-col gap-2 h-fit",
          !expanded && "max-h-9 overflow-hidden",
        )}
      >
        <div className="flex flex-col gap-4 items-start">
          {interactionCheckingData?.drugDrugInteractions.map(
            (interaction, index) => (
              <div
                key={`${medicationRequestId}-${interaction.drugs
                  .map((drug) => drug.code?.coding?.[0]?.code)
                  .join("-")}-${index}`}
                className="flex flex-col gap-1"
              >
                <BodyText size="sm" bold>
                  {SEVERITY_LEVEL_LABELS[interaction.severityLevel]}:{" "}
                  {interaction.drugs.map((drug) => drug.code?.text).join(" - ")}
                </BodyText>
                <BodyText size="sm">{interaction.clinicalDescription}</BodyText>
              </div>
            ),
          )}
          {interactionCheckingData?.drugAllergyInteractions.map(
            (interaction) => (
              <div key={interaction.message} className="flex flex-col gap-1">
                <BodyText size="sm" bold>
                  Allergies
                </BodyText>
                <BodyText size="sm">{interaction.message}</BodyText>
              </div>
            ),
          )}
        </div>
      </div>
      <Button
        variant="link"
        size="sm"
        onClick={() => setExpanded(!expanded)}
        className="w-fit underline font-normal"
      >
        {expanded ? "See Less" : "See More"}
      </Button>
    </Callout>
  );
};
